/** Native swipe/scroll enhanced with dots, arrows and keyboard navigation. */
(function () {
  'use strict';
  var instances = new Map();
  var sequence = 0;

  function enhance(track) {
    if (instances.has(track) || track.children.length < 2) return;
    var items = Array.from(track.children);
    var heading = track.closest('.shopify-section').querySelector('h2');
    var label = heading ? heading.textContent.trim() : 'Collection';
    var oldTabindex = track.getAttribute('tabindex');
    var oldLabel = track.getAttribute('aria-label');
    var generatedId = !track.id;
    if (generatedId) track.id = 'GiftWorksCarousel-' + (++sequence);
    track.setAttribute('tabindex', '0');
    track.setAttribute('aria-label', label + ' items');

    var controls = document.createElement('nav');
    controls.className = 'carousel-controls';
    controls.setAttribute('aria-label', label + ' navigation');
    controls.hidden = true;
    var dots = document.createElement('div');
    dots.className = 'carousel-controls__dots';
    var status = document.createElement('span');
    status.className = 'visually-hidden';
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');

    function arrow(name, symbol) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'carousel-controls__arrow';
      button.setAttribute('aria-label', name);
      button.setAttribute('aria-controls', track.id);
      button.textContent = symbol;
      return button;
    }
    var previous = arrow('Previous items', '\u2039');
    var next = arrow('Next items', '\u203a');
    controls.append(previous, dots, next, status);
    track.after(controls);
    track.classList.add('scroller--enhanced');

    var positions = [];
    var active = 0;
    var frame = 0;
    var rtl = false;
    var events = new AbortController();
    var options = {signal: events.signal};

    function scrollPosition() { return rtl ? -track.scrollLeft : track.scrollLeft; }

    function update() {
      if (!positions.length) return;
      var current = scrollPosition();
      active = positions.reduce(function (closest, position, index) {
        return Math.abs(position - current) < Math.abs(positions[closest] - current) ? index : closest;
      }, 0);
      Array.from(dots.children).forEach(function (dot, index) {
        dot.setAttribute('aria-current', String(index === active));
      });
      previous.disabled = active === 0;
      next.disabled = active === positions.length - 1;
      var message = 'Position ' + (active + 1) + ' of ' + positions.length;
      if (status.textContent !== message) status.textContent = message;
    }

    function go(index) {
      if (controls.hidden) return;
      index = Math.max(0, Math.min(index, positions.length - 1));
      track.scrollTo({
        left: rtl ? -positions[index] : positions[index],
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    function measure() {
      var style = getComputedStyle(track);
      rtl = style.direction === 'rtl';
      var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      var rect = track.getBoundingClientRect();
      var padding = parseFloat(style.paddingInlineStart) || 0;
      var current = scrollPosition();
      var measured = [];
      items.forEach(function (item) {
        var itemRect = item.getBoundingClientRect();
        var distance = rtl ? rect.right - itemRect.right : itemRect.left - rect.left;
        var position = Math.max(0, Math.min(maximum, Math.round(current + distance - padding)));
        if (!measured.some(function (existing) { return Math.abs(existing - position) < 3; })) measured.push(position);
      });
      positions = measured.sort(function (a, b) { return a - b; });
      controls.hidden = maximum < 3 || positions.length < 2;
      track.setAttribute('tabindex', controls.hidden ? '-1' : '0');
      if (dots.children.length !== positions.length) {
        dots.replaceChildren();
        positions.forEach(function (_, index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'carousel-controls__dot';
          dot.setAttribute('aria-label', 'Go to position ' + (index + 1) + ' of ' + positions.length);
          dot.setAttribute('aria-controls', track.id);
          dot.append(document.createElement('span'));
          dot.addEventListener('click', function () { go(index); }, options);
          dots.append(dot);
        });
      }
      update();
    }

    track.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () { frame = 0; update(); });
    }, {passive: true, signal: events.signal});
    previous.addEventListener('click', function () { go(active - 1); }, options);
    next.addEventListener('click', function () { go(active + 1); }, options);
    track.addEventListener('keydown', function (event) {
      if (event.target !== track || controls.hidden) return;
      var target;
      if (event.key === 'ArrowRight') target = active + (rtl ? -1 : 1);
      if (event.key === 'ArrowLeft') target = active + (rtl ? 1 : -1);
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = positions.length - 1;
      if (target === undefined) return;
      event.preventDefault();
      go(target);
    }, options);
    var observer = new ResizeObserver(measure);
    observer.observe(track);
    window.addEventListener('resize', measure, options);
    instances.set(track, function () {
      events.abort();
      observer.disconnect();
      cancelAnimationFrame(frame);
      controls.remove();
      track.classList.remove('scroller--enhanced');
      if (oldTabindex === null) track.removeAttribute('tabindex'); else track.setAttribute('tabindex', oldTabindex);
      if (oldLabel === null) track.removeAttribute('aria-label'); else track.setAttribute('aria-label', oldLabel);
      if (generatedId) track.removeAttribute('id');
      instances.delete(track);
    });
    measure();
  }

  function initialize(root) { root.querySelectorAll('.scroller').forEach(enhance); }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (destroy, track) { if (event.target.contains(track)) destroy(); });
  });
})();
